module.exports = __webpack_public_path__ + "static/media/materdei_placeholder.754cfffc.png";